import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components/icons/CheckCircleIcon.tsx
var i = (e) => /* @__PURE__ */ n(t, {
	viewBox: "0 0 24 24",
	fill: "none",
	...e,
	children: /* @__PURE__ */ n("path", {
		d: "M21 12C21 7.02948 16.9705 3 12 3C7.02948 3 3 7.02948 3 12C3 16.9705 7.02948 21 12 21C16.9705 21 21 16.9705 21 12ZM15.793 8.29297C16.1835 7.90244 16.8165 7.90244 17.207 8.29297C17.5976 8.68349 17.5976 9.31651 17.207 9.70703L11.207 15.707C10.8165 16.0976 10.1835 16.0976 9.79297 15.707L6.79297 12.707C6.40244 12.3165 6.40244 11.6835 6.79297 11.293C7.18349 10.9024 7.81651 10.9024 8.20703 11.293L10.5 13.5859L15.793 8.29297ZM23 12C23 18.0751 18.0751 23 12 23C5.92492 23 1 18.0751 1 12C1 5.92492 5.92492 1 12 1C18.0751 1 23 5.92492 23 12Z",
		fill: "currentColor"
	})
}), a = {
	12: {
		Artwork: i,
		width: 12,
		height: 12
	},
	16: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: [/* @__PURE__ */ n("path", {
				d: "M10.4702 5.47021C10.7631 5.17732 11.2379 5.17732 11.5308 5.47021C11.8233 5.76313 11.8235 6.23798 11.5308 6.53076L7.53076 10.5308C7.23798 10.8235 6.76313 10.8233 6.47021 10.5308L4.47021 8.53076C4.17732 8.23787 4.17732 7.76311 4.47021 7.47021C4.76311 7.17732 5.23787 7.17732 5.53076 7.47021L7.00049 8.93994L10.4702 5.47021Z",
				fill: "currentColor"
			}), /* @__PURE__ */ n("path", {
				d: "M8.00049 0.583496C12.0964 0.583672 15.4165 3.90452 15.4165 8.00049C15.4163 12.0963 12.0963 15.4163 8.00049 15.4165C3.90452 15.4165 0.583672 12.0964 0.583496 8.00049C0.583496 3.90441 3.90441 0.583496 8.00049 0.583496ZM8.00049 2.0835C4.73284 2.0835 2.0835 4.73284 2.0835 8.00049C2.08367 11.268 4.73294 13.9165 8.00049 13.9165C11.2679 13.9163 13.9163 11.2679 13.9165 8.00049C13.9165 4.73294 11.268 2.08367 8.00049 2.0835Z",
				fill: "currentColor"
			})]
		}),
		width: 16,
		height: 16
	},
	20: {
		Artwork: i,
		width: 20,
		height: 20
	},
	24: {
		Artwork: i,
		width: 24,
		height: 24
	}
}, o = ({ size: t = 16, tone: r = "default", className: i, ...o }) => /* @__PURE__ */ n(e, {
	source: a[t],
	monochrome: !0,
	className: ["pf-icon-" + r, i].filter(Boolean).join(" "),
	...o
});
//#endregion
export { o as CheckCircleIcon };
